import { render, staticRenderFns } from "./nbn.vue?vue&type=template&id=0411266a&"
import script from "./nbn.vue?vue&type=script&lang=js&"
export * from "./nbn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports